module.exports = __webpack_public_path__ + "static/media/wifi.f7ad4caa.svg";